import AdditionalWarning from './AdditionalWarning';

export default AdditionalWarning;